import { useQuery } from 'react-query';
import { useTokenizedApi } from '../useTokenizedApi';
import { useProfile } from '../entities/useProfile';
import { useIntl } from '../intl/useIntl';
import { useInstrumentListWithDetails } from '../treasury/useInstrumentListWithDetails';
import { useContract } from '../contracts/useContract';

/** @category Entities and Profiles */
export function useActivityEvent(activityEvent) {
  const tokenizedApi = useTokenizedApi();
  const intl = useIntl();

  const profileId = activityEvent?.profileId;
  const entityId = useProfile(profileId)?.entityId;

  const instruments = useInstrumentListWithDetails(
    tokenizedApi.activity.instrumentsNeededForEventPreparation(activityEvent),
    profileId,
  );
  const instrumentsById = new Map(
    instruments.map((instrument) => [instrument.instrumentId, instrument]),
  );

  let contractsById = useQuery(
    tokenizedApi.contracts.contractsQuery({ profileId }),
  )?.data?.idMap;

  const proposedContractAddress =
    activityEvent?.contract?.contractAddress &&
    contractsById &&
    !contractsById.has(activityEvent.contract.contractAddress)
      ? activityEvent.contract.contractAddress
      : null;
  const proposedContract = useContract(
    proposedContractAddress,
    profileId,
    false,
  )?.data;
  if (proposedContractAddress && proposedContract) {
    contractsById = new Map(contractsById);
    contractsById.set(proposedContractAddress, proposedContract);
  }

  return tokenizedApi.activity.prepareEventForRender({
    event: activityEvent,
    intl,
    instrumentsById,
    contractsById,
    entityId,
  });
}
